<!-- Energy widget version: 1.0 -->
<script lang="ts">
	import EmConsumerMix from 'src/components/EnergyMonitoring/sections/EmConsumerMix.svelte';
	import { Container } from '@Shelly/shelly-design-system';
	import { normalizeEnergyConfig } from '../../../../dash-energy-helpers';
	import type { DashEnergyWidgetConfig } from '../../../../dash-energy-types';

	export let energyConfig: DashEnergyWidgetConfig<'dashEnergyConsumerMix'> | undefined;
	export let staticPreview = false;
	export let showClassificationAction = false;

	$: config = normalizeEnergyConfig('dashEnergyConsumerMix', energyConfig);
</script>

<Container type="glass" noScroll fullHeight>
	<EmConsumerMix
		embedded
		{staticPreview}
		{showClassificationAction}
		showLegend={config.showLegend !== false}
		minSharePercent={config.minSharePercent}
	/>
</Container>
